module.exports = __webpack_public_path__ + "img/genshin.58be05b.png";